const HAS_CHILDCARE_ROLES_KEY = "has-childcare-roles";

export function setHasChildcareRoles(value: boolean, workerId: string): void {
  localStorage.setItem(`${HAS_CHILDCARE_ROLES_KEY}::${workerId}`, JSON.stringify(value));
}

export function getHasChildcareRoles(workerId: string): boolean {
  const stored = localStorage.getItem(`${HAS_CHILDCARE_ROLES_KEY}::${workerId}`);
  if (stored === null) {
    return false;
  }

  try {
    return JSON.parse(stored) === true;
  } catch {
    return false;
  }
}
